/** Amount not yet represented by registered entries for a recurring occurrence. */
export function recurrenceRemainder(amount:number,matching:{amount:number;status:string}[]){
 if(matching.some(t=>t.status==='cancelled'))return 0
 return Math.max(0,Math.round((amount-matching.reduce((sum,t)=>sum+Number(t.amount),0))*100)/100)
}
